import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)
import Layout from '@/layout/'

const routers = [
  {
    path: '/',
    component: Layout,
    redirect: { name: 'Home' },
    children: [
      {
        path: '',
        name: 'Home',
        meta: { title: '首页' },
        component: () => import('@/views/index/index')
      },
      {
        path: 'list',
        name: 'ResourceList',
        component: () => import('@/views/resource/List')
      },
      {
        path: 'info/:resId',
        name: 'ResourceInfo',
        component: () => import('@/views/resource/Info')
      },
      {
        path: 'search/:scope/:content',
        name: 'Search',
        component: () => import('@/views/search')
      },
      {
        path: 'adv-search',
        name: 'AdvSearch',
        component: () => import('@/views/search/AdvSearch')
      }
    ]
  },
  {
    path: '/reader',
    name: 'ReaderWrap',
    component: () => import('@/layout/ReaderLayout'),
    children: [
      {
        path: 't/:type/:resId',
        name: 'Reader',
        component: () => import('@/views/reader')
      }
    ]
  }
]

export default new VueRouter({
  mode: 'history',
  scrollBehavior: () => ({ y: 0, behavior: 'smooth' }),
  routes: routers
})
